import { useTranslation } from 'react-i18next';

import type { StoreProductStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const STYLES: Record<StoreProductStatus, string> = {
  published: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  draft: 'bg-secondary text-secondary-foreground border-transparent',
  unpublished: 'border-border text-muted-foreground',
};

/** Green for live, neutral for draft, outlined for taken down. */
export function StoreProductStatusBadge({
  status,
  className,
}: {
  status: StoreProductStatus;
  className?: string;
}) {
  const { t } = useTranslation('storeCatalog');
  return (
    <Badge variant="outline" className={cn(STYLES[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
